import advertApi from './api/advertApi';

export const ADUNIT_LIST = 'ADUNIT/LIST';


const initialState = {
	adUnit: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ADUNIT_LIST:
			return {
				...state,
				adunits: action.payload
			};
		default:
			return state;
	}
};

export const adunitList = (payload = {}) => {
	return dispatch => {
		const hasQuery = payload && Object.keys(payload).length > 0;
		const queryString = hasQuery ? `?${new URLSearchParams(payload).toString()}` : '';
		return advertApi.get(`/adUnits${queryString}`).then(data => {
			dispatch({
				type: ADUNIT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const adunitUpdate = (id, payload) => {
	return dispatch => {
		return advertApi.patch(`/adUnits/` + id, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const adunitModeration = (id, payload) => {
	return dispatch => {
		return advertApi.patch(`/adUnits/moderation/${id}`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const adunitDelete = (id, payload) => {
	return dispatch => {
		return advertApi.delete(`/adUnits/moderation/${id}`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const adunitCreate = (payload) => {
	return dispatch => {
		return advertApi.post(`/adUnits`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
